import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      {/* Header simples */}
      <header className="w-full px-4 md:px-8 py-5 flex items-center justify-center border-b border-background-200/70">
        <Link
          to="/"
          className="font-heading text-xl font-bold text-foreground-950 tracking-tight hover:opacity-80 transition-opacity"
        >
          Joint<span className="text-primary-500">Genesis</span>
        </Link>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-lg w-full text-center">
          {/* Success icon */}
          <div className="mx-auto w-20 h-20 rounded-full bg-accent-100 flex items-center justify-center mb-6">
            <i className="ri-check-line text-accent-500 text-3xl" />
          </div>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Guia enviado com sucesso!
          </h1>

          <p className="text-foreground-600 text-lg leading-relaxed mb-8">
            Seu guia <strong className="text-foreground-950">&ldquo;7 Erros que Aceleram o Desgaste das Articulacoes Apos os 50 Anos&rdquo;</strong> foi enviado para o seu email.
          </p>

          {/* What to expect card */}
          <div className="bg-white rounded-2xl border border-background-200/70 p-6 mb-8 text-left">
            <h2 className="font-heading text-lg font-bold text-foreground-950 mb-4">
              O que voce vai descobrir no guia:
            </h2>
            <ul className="space-y-3">
              {[
                "Os 7 erros diarios que aceleram silenciosamente o desgaste articular",
                "Por que a lubrificacao natural das articulacoes diminui com a idade",
                "Alimentos e habitos que ajudam a preservar a mobilidade",
                "O que os pesquisadores estao descobrindo sobre o acido hialuronico",
                "Dicas praticas para manter-se ativo e sem desconforto",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-foreground-700 text-sm leading-relaxed">
                  <div className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-500 text-xs" />
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* CTA to go back */}
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl bg-primary-500 text-white font-bold text-base hover:bg-primary-600 transition-all hover:scale-[1.02] active:scale-[0.98] whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Voltar para a pagina principal
            </Link>

            <p className="text-foreground-400 text-sm">
              Nao recebeu o email? Verifique a pasta de spam ou{" "}
              <a
                href="mailto:suporte@jointgenesis.com"
                className="text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors"
              >
                entre em contato
              </a>
              .
            </p>
          </div>
        </div>
      </main>

      {/* Footer simples */}
      <footer className="w-full px-4 md:px-8 py-6 border-t border-background-200/70 text-center">
        <p className="text-foreground-400 text-xs">
          &copy; {new Date().getFullYear()} JointGenesis. Todos os direitos reservados.
        </p>
      </footer>
    </div>
  );
}